import {setToken, getToken, getMenuByRouter} from '@/libs/util'
import {dataGet} from '@/api/data'

import router from '@/router'

export default {
  state: {
    userName: '',
    userId: '',
    mobile: '',
    avatar: '',
    token: getToken(),
    //权限列表
    permission: [],
    hasGetInfo: false,
    menuRouters: [], //
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    addRouters (state, routers) {  //
      for (let i = 0; i < routers.length; i++) {
        state.menuRouters.push(routers[i])
      }
      router.options.routes = routers
      router.addRoutes(routers)
    },
    //登录设置
    setLogin (state, data) {
      state.expired = data.expired
      state.userName = data.account
      state.userId = data.uid
      state.mobile = data.mobile
      state.token = data.token
      state.permission = data.permission
      setToken(data.token)
      state.hasGetInfo = true
    },
    //退出登录
    setLogout (state) {
      state.userName = ''
      state.userId = ''
      state.mobile = ''
      state.token = ''
      setToken('')
      state.hasGetInfo = false
    }
  },
  getters: {
    getToken: state => state.token,
    getUserId: state => state.userId,
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access)
  },
  actions: {
    // 登录
    handleLogin ({commit}, {token}) {
      return new Promise((resolve, reject) => {
        commit('setToken', token)
        resolve()
      })
    },
    // 退出登录
    handleLogOut ({state, commit}) {
      return new Promise((resolve, reject) => {
        commit('setLogout')
        location.reload()
        resolve()
        // logout().then(() => {
        //
        // }).catch(err => {
        //   reject(err)
        // })
      })
    },
    // 获取用户相关信息
    getUserInfo ({state, commit}) {
      return new Promise((resolve, reject) => {
        try {
          dataGet('/api/own/get').then(response => {
            if (response.status == 1000) {
              //授权失败，清空token
              commit('setLogout')
              reject()
            } else if (response.status == 200) {
              commit('setLogin', response.result)
              resolve(response.result)
            } else {
              reject()
            }
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js